export const settings = {
	PROGS_URL: '/wp-json/fsgo/prog',
	NOT_ALLOWED_MOBILE_STREAMING_TAG: 0,
	SF_POST_TYPE: 'fox_sectionfront',
	REGIONAL_SF: 'r_sf',
	REGIONAL_POST: 'r_p',
	NATIONAL_SF: 'n_sf',
	NATIONAL_POST: 'n_p'
};
